import { apiClient, unwrapApi } from './http';

/**
 * Users API — /users/*
 */
export async function getUsers() {
  const { data } = await apiClient.get('/users');
  return unwrapApi(data);
}

export async function getUser(id) {
  const { data } = await apiClient.get(`/users/${id}`);
  return unwrapApi(data);
}

export async function getDesigners() {
  const { data } = await apiClient.get('/users/designers');
  return unwrapApi(data);
}

export async function updateUser(id, payload) {
  const { data } = await apiClient.put(`/users/${id}`, payload);
  return unwrapApi(data);
}

export async function deleteUser(id) {
  const { data } = await apiClient.delete(`/users/${id}`);
  return unwrapApi(data);
}

export async function toggleUserStatus(id) {
  const { data } = await apiClient.put(`/users/${id}/status`);
  return unwrapApi(data);
}

const usersService = {
  getUsers,
  getUser,
  getDesigners,
  updateUser,
  deleteUser,
  toggleUserStatus,
};

export default usersService;
